import React from 'react'
import { useForm } from 'react-hook-form'
import { SearchOutlined } from '@ant-design/icons'

import { LntButton, LntForm, LntFormItem, LntInput, LntSelect } from '@app/components/base'

import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { BUTTON_TYPE, SIZE } from '@app/constants'

import { DEFAULT_VALUES } from './constants'
import { filterOptions } from './config'

import styles from './styles.module.scss'

import type { TopFilterProps, AddProductsFormData } from './types'

export const TopFilters: React.FC<TopFilterProps> = ({ onSearch }) => {
  const form = useForm<AddProductsFormData>()
  const isExistValue = !!form.watch('filterValue')

  const handleResetFilter = (): void => {
    form.reset(DEFAULT_VALUES)
  }

  const handleSubmit = (formData: AddProductsFormData): void => {
    const { filterName, filterValue } = formData

    onSearch({ [filterName]: filterValue })
  }

  return (
    <LntForm
      className={ styles.topFilter__head }
      onSubmit={ handleSubmit }
      formInstance={ form }
    >
      <div className={ styles.topFilter__wrapper }>
        <div className={ styles.topFilter__head }>
          <LntFormItem
            className={ styles.topFilter__select }
            name='filterName'
            defaultValue={ DEFAULT_VALUES.filterName }
          >
            <LntSelect
              options={ filterOptions }
              showArrow
            />
          </LntFormItem>

          <LntFormItem
            className={ styles.topFilter__input }
            name='filterValue'
            defaultValue=''
          >
            <LntInput placeholder={ FILTERS_PLACEHOLDERS.filterValue } />
          </LntFormItem>
        </div>
        <div className={ styles.topFilter__buttons }>
          <LntButton
            htmlType='reset'
            type={ BUTTON_TYPE.text }
            size={ SIZE.middle }
            onClick={ handleResetFilter }
            disabled={ !isExistValue }
          >
            Сбросить
          </LntButton>

          <LntButton
            icon={ <SearchOutlined /> }
            type={ BUTTON_TYPE.primary }
            size={ SIZE.middle }
            htmlType='submit'
            disabled={ !isExistValue }
          >
            Найти
          </LntButton>
        </div>
      </div>
    </LntForm>
  )
}
